import {
  Component,
  OnInit,
  ChangeDetectionStrategy, Input, ViewChild, ElementRef, Output, EventEmitter, ChangeDetectorRef, ViewContainerRef
} from '@angular/core';
import { isEqual, uniqBy, cloneDeep, isEmpty } from 'lodash';
import { ModalTypes } from '@ispm/layout/components/modals/contants/modal-types.enum';
import { DynamicModalLoaderService } from '@ispm/layout/services/dynamic-modal-loader.service';
import { ConfirmModalComponent } from '@ispm/layout/components/modals/confirm-modal/confirm-modal.component';
import { ConfirmModalLoaderPayload } from '@ispm/layout/classes/confirm-modal-loader-payload';
import {Iitem} from "@ispm-client/modules/selection-item/interfaces/floatingPanel.interface";

@Component({
  selector: 'generic-sub-selection',
  templateUrl: './generic-sub-selection.component.html',
  styleUrls: ['./generic-sub-selection.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})


export class GenericSubSelectionComponent implements OnInit {
  public selectedItems: any = [];
  public subFormData: any;
  public formData: any;
  private formUpdated: boolean = false;
  public reset: boolean = false;
  public isValid: boolean;
  public resetFormData: boolean = true;
  public pncSource: boolean = true;

  public formConfig: any;
  @Input() selectionType: string;
  @Input() subItems: any  = [];
  @Input() sortByItem: string;
  public sortByIndex: string = 'sortIndex';
  /**  private _subItems: any = [];
   @Input()
   set subItems(items){
    if(items){
      this._subItems = items.map(item => {
        if(item.nodeType !== 'form'){
          item = { config:[DynamicFormItem.from(item).setOptions(item.list).setType(item.nodeType)], nodeType: 'form'}
        }
        return item;
      });
    }
  };

   get subItems(){
    return this._subItems;
  }*/
  @Input() totalSelectedItemsCount: number = 0;
  @Input() restrictItemsCount: number;
  @Input() restrictionMessage: string = '';

  public subSelectionPanelClose: boolean = false;
  @Input() set subSelectionPanel(subSelectionPanel: boolean) {
    this.subSelectionPanelClose = subSelectionPanel;
    this.ClearItemsData();
    this.updateSelectedItems();
    this.resetFormData = true;
  }
  get subSelectionPanel() {
    return this.subSelectionPanelClose;
  }

  @Input() permitItemSelectionWrite: boolean;
  @Input() pncStatus: boolean;

  @ViewChild('genericSubSelection', { static: false, read: ViewContainerRef }) entry: ViewContainerRef;
  public nested: boolean = false;
  nestedItems: Map<string, Array<any>> = new Map<string, Array<any>>();

  public totalSelectedItemLists: any = [];
  @Input() set totalSelectedItemList(totalSelectedItemList: Array<any>) {
    this.totalSelectedItemLists = totalSelectedItemList;
    this.ClearItemsData();
    this.updateSelectedItems();
    this.resetFormData = true;
  }
  get totalSelectedItemList() {
    return this.totalSelectedItemLists;
  }

  @Output()
  emitSelectedItems: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  emitSubSelectionPanelClose: EventEmitter<any> = new EventEmitter<any>();

  public componentRef: any;
  @ViewChild('subSelectionPanel', { static: false, read: ElementRef}) public panel: ElementRef;

  constructor( private _changeDetector: ChangeDetectorRef,
               private modalLoader: DynamicModalLoaderService) {
  }

  ngOnInit() {
    this.pncSource = this.pncStatus === true ? true : false;
  }

  /**
   * clear all the selected items data
   * @constructor
   */
  ClearItemsData() {
    if(this.resetFormData) {
      this.subItems.list.forEach((subItem) => {
        subItem[subItem.formRefName] = null;
        subItem.selected = false;
        subItem.code = false;
        this.deleteAttributes(subItem);
        if (subItem.list.length > 0) {
          subItem.list.forEach((groupItem) => {
            groupItem[groupItem.formRefName] = null;
            groupItem.selected = false;
            groupItem.code = false;
            this.deleteAttributes(groupItem);
          });
        }
      });
    }
  }

  /**
   * delete the unwanted attributes
   * @param subItem
   * @returns {any}
   */
  deleteAttributes(subItem: object) {
    delete subItem['deleted'];
    delete subItem['updated'];
    return subItem;
  }

  /**
   * handled seelcted items data
   */
  updateSelectedItems() {
    if (Array.isArray(this.totalSelectedItemLists) && this.totalSelectedItemLists.length > 0) {

      this.subItems.list.forEach((subItem) => {
        return this.totalSelectedItemLists.filter((selectedItem) => {
          if (subItem.list.length === 0 && !selectedItem.formData) {
            if (subItem.itemId === selectedItem.itemId) {
              subItem.code = true;
              subItem.selected = true;
            }
          }
          else if (subItem.list.length === 0 && selectedItem.formData && this.resetFormData) {
            const formRefName = selectedItem.itemReferences[selectedItem.itemReferences.length - 1].reference;
            if (subItem.formRefName === formRefName) {
              subItem[subItem.formRefName] = selectedItem.formData;
            }
          }
          else if (subItem.list.length > 0 && !selectedItem.formData) {
            subItem.list.forEach((groupItem) => {
              if (groupItem.itemId === selectedItem.itemId) {
                groupItem.code = true;
                groupItem.selected = true;
              }
            });
          }
          else if (subItem.list.length > 0 && selectedItem.formData && this.resetFormData) {
            subItem.list.forEach((groupItem) => {
              const formRefName = selectedItem.itemReferences[selectedItem.itemReferences.length - 1].reference;
              if (groupItem.formId && groupItem.formRefName === formRefName) {
                groupItem[groupItem.formRefName] = selectedItem.formData;
              }
            });
          }
        });
      });
    }
    this._changeDetector.markForCheck();
    this._changeDetector.detectChanges();
  }

  /**
   * Going back to first level
   */
  scrollBackward(): void {
    if (this.formUpdated) {
      this.emitSelectedItems.emit(this.selectedItems);
    }
    if(this.nestedItems.get(this.subItems['itemId'])) {
      this.subItems = this.nestedItems.get(this.subItems['itemId']);
      this.nestedItems.delete(this.subItems['itemId']);
    }else {
      this.selectedItems = [];
      this.subSelectionPanelClose = false;
      this.emitSubSelectionPanelClose.emit(this.subSelectionPanelClose);
    }
  }

  /**
   * handled tab selection
   * @param item
   */
  openSubItem(item: any) {
    if (this.restrictItemsCount && this.totalSelectedItemsCount > this.restrictItemsCount && item['selected'] === false) {
      item.selected = false;
      this.resetFormData = true;
      this.showAlertMessage();
    }else {
      if(item.list.length === 0) {
        if(this.permitItemSelectionWrite) {
          item.selected = item.selected ? false : true;
          let cloneItem = cloneDeep(item);
          cloneItem.itemReferences = cloneItem.referencePath;
          this.resetFormData = false;
          this.emitSelectedItems.emit(cloneItem);
        }
      }else {
        this.nested = true;
        this.subItems = item;
        this.nestedItems.set(item['itemId'], item);
      }
    }
  }

  /**
   * handled checkbox selection
   * @param item
   */
  toggleVisibility(item: Iitem) {
    if (this.permitItemSelectionWrite) {
      if (this.restrictItemsCount && item.code === true && this.totalSelectedItemsCount > this.restrictItemsCount) {
        this.resetFormData = true;
        this.showAlertMessage();
      } else {
        const cloneItem = cloneDeep(item);
        cloneItem.itemReferences = cloneItem.referencePath;
        this.resetFormData = false;
        this.emitSelectedItems.emit(cloneItem);
      }
    }
  }

  /**
   * Popup notification when selected items count exceeds the restrictedCount
   */
  showAlertMessage() {
    this.modalLoader.popupModal(ConfirmModalComponent,
      new ConfirmModalLoaderPayload(
        '',
        ` ${this.restrictionMessage} ${this.restrictItemsCount}`, '', 'OK'),
      ModalTypes.ALERT)
      .subscribe(res => {
          this.reset = true;
          this.ClearItemsData();
          this.updateSelectedItems();
          this._changeDetector.markForCheck();
      });
  }

  /**
   * handled form node requirement
   * @param data
   * @param formItem
   * @param groupReference
   * @param dataExist
   */
  updateFormData(data: object, formItem: any, groupReference: Iitem, dataExist: any) {
    if (this.permitItemSelectionWrite) {
      if (this.restrictItemsCount && this.totalSelectedItemsCount > this.restrictItemsCount && isEmpty(dataExist)) {
        this.reset = true;
        this.showAlertMessage();
      } else {
        if (!this.isValid) {
          return;
        } else {
          this.subFormData = data['form'];
          this.formUpdated = true;
          delete this.subFormData['id'];
          delete this.subFormData['meta'];
          delete this.subFormData['formId'];

          formItem['formData'] = this.subFormData;
          const cloneItem = cloneDeep(formItem);
          cloneItem['itemReferences'] = this.createReference(cloneItem, groupReference);
          let itemExist = false;
          if(this.selectedItems && this.selectedItems.length > 0 ) {
            this.selectedItems.forEach( item => {
              if (isEqual(item.itemReferences, cloneItem.itemReferences)) {
                item.formData = cloneItem.formData;
                itemExist = true;
              }
            });
            if(!itemExist) {
              this.selectedItems.push(cloneItem);
            }
          } else {
            this.selectedItems.push(cloneItem);
          }
        }
      }
    }
  }

  /**
   * create reference for form node
   * @param cloneItem
   * @param groupReference
   * @returns {any}
   */
  createReference(cloneItem: any, groupReference: Iitem): any {
    if (cloneItem[groupReference.itemId]) {
      delete cloneItem[groupReference.itemId];
    }
    if (groupReference.itemId) {
      if (cloneItem['itemReferences'] === undefined) {
        cloneItem['itemReferences'] = [];
      }
      cloneItem['itemReferences'] = cloneItem.referencePath;
      cloneItem['itemReferences'].push({ 'reference': groupReference.itemId,
        'display': groupReference.itemName});
    }
    return uniqBy(cloneItem.itemReferences, 'reference');
  }

  updateValidate(validate: boolean) {
    this.isValid = validate;
  }

}

